import { loader, Sprite } from 'pixi.js';

class LoaderItem {
    public sprite?: Sprite;

    constructor(
        public readonly link: string,
        public readonly name: string,
        public readonly callback?: Function,
    ) {}
}

const storageCache: Map<string, LoaderItem> = new Map();
let queryItems: LoaderItem[] = [];

type getSpriteFromURLType = {
    sprite: Sprite;
    cached: boolean;
}

const cachedSprites = new Map<string, Sprite | null>();
const resForLoad = new Map<string, { url: string, resolve: Function }>();

export function getSpriteFromUrl(url: string, resName: string): Promise<getSpriteFromURLType> {
    return new Promise((resolve, reject) => {
        if (!url || !resName) {
            return reject("getSpriteFromUrl :: Bad args");
        }

        const cacheItem = storageCache.get(resName);
        if (cacheItem) {
            if (cacheItem.sprite && cacheItem.sprite.texture) {
                return resolve({
                    sprite: new Sprite(cacheItem.sprite.texture),
                    cached: true,
                })
            } else {
                console.log("Founded empty cache file!");
            }
        }

        queryItems.push(new LoaderItem(
            url,
            resName,
            resolve,
        ))
    })
}

function RunNextIter(): void {
    setTimeout(MakeIter, 100);
}

function MakeIter(): void {
    if (loader.loading || queryItems.length <= 0) {
        return void RunNextIter();
    }

    const currentQuery = [...queryItems];
    queryItems = [];

    const inQueryNames: string[] = []

    currentQuery.forEach(item => {
        if (loader.resources[item.link]) return;
        if (!~inQueryNames.includes(item.link)) return;

        inQueryNames.push(item.link);
        loader.add(item.link, item.link);
    });

    loader.load((loader, resources) => {
        currentQuery.forEach((item) => {
            if (!storageCache.get(item.name)) {
                storageCache.set(item.name, item);
                item.sprite = new Sprite(loader.resources[item.link].texture);
                item.callback({
                    sprite: new Sprite(item.sprite.texture),
                    cached: false
                });
            } else {
                const currentItem = storageCache.get(item.name);
                item.callback({
                    sprite: new Sprite(currentItem.sprite.texture),
                    cached: true
                });
            }
        });

        RunNextIter();
    })
}

MakeIter();